import styled from 'styled-components';

import { BiggerSubtitle } from '../../../../../foundations/typefaces/BiggerSubtitle';
import { mixins } from '../../../../../style/mixins';

interface WrapperProps {
  $hasBorderBottom: boolean;
}

interface TopWrapperProps {
  $hasPadding: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { color }, $hasBorderBottom }) => ({
    display: 'flex',
    flexDirection: 'column',
    borderBottom: $hasBorderBottom
      ? `1px solid ${color.border.secondary.default()}`
      : undefined,

    ...mixins.responsive.sm.downward({
      borderBottom: 'none',
    }),
  }),
);

export const Title = styled(BiggerSubtitle)({
  textAlign: 'center',
  width: '100%',
});

export const DesktopTitleWrapper = styled.div({
  display: 'flex',
  flexGrow: 1,

  ...mixins.responsive.sm.downward({
    display: 'none',
  }),
});

export const MobileTitleWrapper = styled.div({
  display: 'none',
  flexGrow: 1,

  ...mixins.responsive.sm.downward({
    display: 'flex',
  }),
});

export const SmallTitle = styled(BiggerSubtitle)({
  textAlign: 'center',
  width: '100%',
});

export const AdditionalElementWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
  width: '22%',
  padding: 0,

  ...mixins.responsive.sm.downward({
    flexGrow: 1,
    padding: `0 ${size.units(4)}`,
  }),
}));

export const HamburguerMenuIconWrapper = styled.div({
  display: 'none',
  ...mixins.responsive.sm.downward({
    display: 'flex',
  }),
});

export const CloseIconWrapper = styled.div({});

export const StyledIcon = styled.i(({ theme: { color, transition, size } }) => ({
  cursor: 'pointer',
  color: color.content.secondary.default(),
  transition: transition.standard(),
  fontSize: size.units(2),

  ':hover': {
    color: color.content.secondary.hover(),
  },

  ':focus': {
    color: color.content.secondary.hover(),
  },

  ':focus-visible': {
    outline: 'auto -webkit-focus-ring-color',
  },
}));

export const TopWrapper = styled.div<TopWrapperProps>(
  ({ theme: { size }, $hasPadding }) => ({
    display: 'flex',
    padding: $hasPadding
      ? `${size.units(3)} ${size.units(2)} ${size.units(2)}`
      : undefined,
    gap: size.units(1),
    height: 'auto',
    justifyContent: 'space-between',
    position: 'relative',

    [CloseIconWrapper]: {
      position: 'absolute',
      right: size.units(2),
      top: size.units(3),
    },

    [HamburguerMenuIconWrapper]: {
      position: 'absolute',
      left: size.units(2),
      top: size.units(3),
    },
  }),
);
